import React from 'react';
import PropTypes from 'prop-types';

import ArticleCard from '../../components/ArticleCard';

import sitemapClasses from '../../css/sitemap.module.css';
import classes from './AdviceExplorer.module.css';

const Header = (props) => {
  const { isHomePage, headerText, customTitle } = props;
  if (!customTitle) {
    if (isHomePage && headerText && headerText.length) {
      return (
        <div className="main_inner">
          <h2 className="brandonH2 sec-head text-center">{headerText}</h2>
        </div>
      );
    }
    if (isHomePage) {
      return (
        <div className="main_inner">
          <h2 className="brandonH2 sec-head text-center">RESOURCES</h2>
        </div>
      );
    }
    return (
      <div className={sitemapClasses['siteMapTopLevelCareer']}>
        <h2 className="sectionTitle brandonH1">RESOURCES</h2>
      </div>
    );
  }

  return customTitle && headerText && headerText.length ? (
    <div className="z-mb-10 brandonH2 z-mb-48">
      <h2 className="z-mb-10 brandonH2">{headerText}</h2>
    </div>
  ) : (
    <div className={sitemapClasses['siteMapTopLevelCareer']}>
      <h2 className="sectionTitle brandonH1">RESOURCES</h2>
    </div>
  );
};

const AdviceExplorer = (props) => {
  const {
    isHomePage,
    isDapPage,
    desktopDevice,
    newsArticles,
    title,
    explore,
    className,
    id,
    headerText,
    showAllResourcesLink = false,
    customTitle,
  } = props;
  const openInNew = desktopDevice ? { target: '_blank' } : {};

  return (
    <section className={`${className} ${isDapPage ? classes['mb-63'] : ''}`} id={id}>
      {title && (
        <Header isHomePage={isHomePage} headerText={headerText} customTitle={customTitle} />
      )}

      <div className="row articleCardsGridContainer">
        {newsArticles.map((article, index) => (
          <ArticleCard key={index} openInNew={openInNew} article={article} />
        ))}
      </div>
      {explore || showAllResourcesLink ? (
        <div className={sitemapClasses['all-ExploreNews']}>
          <a className="blueZippiaColor" href="/research/get-your-first-job-resources/">
            All Jobs Resources
          </a>
        </div>
      ) : (
        <></>
      )}
    </section>
  );
};

AdviceExplorer.propTypes = {
  title: PropTypes.bool,
  explore: PropTypes.bool,
  desktopDevice: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isDapPage: PropTypes.bool,
  customTitle: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  newsArticles: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      articleSlug: PropTypes.string,
    })
  ),
};

AdviceExplorer.defaultProps = {
  title: true,
  explore: true,
  desktopDevice: true,
  isHomePage: false,
  isDapPage: false,
  customTitle: false,
  className: 'container',
  id: 'advices-explore',
  newsArticles: [],
};

export default AdviceExplorer;
